import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import ManagedOrgPageContent from '@shared/components/organization/managedOrg/ManagedOrgPageContent';
import { useTranslation } from 'react-i18next';

export default function OrgManagedOrgsPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <>
            <PageHeader
                title={t('common:organization.managed.titlePlural')}
                description={t('common:organization.managed.description')}
                items={items}></PageHeader>
            <ManagedOrgPageContent />
        </>
    );
}
